/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { action } from '@ember/object';

export default class AvatarListItem extends Component {
  // passed in
  onClick = null;

  image = null;
  @tracked initials = null; // optional override; computed from primaryText if omitted
  @tracked primaryText = null;
  secondaryText = null;
  hasCheckbox = false;
  alertText = null;

  @action
  handleClick() {
    if (this.onClick) {
      this.onClick();
    }
  }

  get resolvedInitials() {
    if (this.initials) return this.initials;
    return (this.primaryText || '')
      .split(' ')
      .map((w) => w[0])
      .slice(0, 2)
      .join('')
      .toUpperCase();
  }
}
